// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_o0-0";